import { supabase } from './supabaseClient';

const allMonths = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

export async function fetchScaleFromSupabase(scaleId) {
  if (!supabase) return null;

  const { data, error } = await supabase
    .schema('cortivox')
    .from('question_bank')
    .select('*')
    .contains('scale_ids', [scaleId]);

  if (error || !data || data.length === 0) return null;

  const questions = data.map(item => {
    const question = {
      id: item.step_id,
      type: item.question_type,
      ask: item.question_text,
      ...item.config 
    };

    if (item.tts_text) question.ttsText = item.tts_text;
    if (item.image_url) question.imageUrl = item.image_url;
    if (item.audio_url) question.audioUrl = item.audio_url;

    if (question.calendarCheck === 'month') {
      const currentMonth = allMonths[new Date().getMonth()];
      question.correctOption = currentMonth;
      question.validAnswer = currentMonth.toLowerCase();
      const others = allMonths.filter(m => m !== currentMonth).sort(() => 0.5 - Math.random()).slice(0, 3);
      question.options = [...others, currentMonth].sort(() => 0.5 - Math.random());
    }

    return question;
  });

  // Правильная сортировка (1a, 1b, 2a... 10a, 11a)
  questions.sort((a, b) => {
    const numA = parseInt(a.id.match(/\d+/)?.[0] || 0);
    const numB = parseInt(b.id.match(/\d+/)?.[0] || 0);
    if (numA !== numB) return numA - numB;
    return a.id.localeCompare(b.id);
  });

  return {
    id: scaleId,
    name: scaleId.toUpperCase(),
    questions: questions
  };
}